/** @format */

import React from 'react';
import { useSiteData, DataContextProps } from '@context';

/**
 * Top Header Bar.
 */
const TopHeaderBar: React.FC<{ pageType?: string }> = () => {
  const { siteData }: DataContextProps = useSiteData();
  if (!siteData) return null;

  const { translations } = siteData;

  /**
   * Render.
   */
  return (
    <div className="top-bar-wrapper">
      <div className="top-bar-container container large">
        <nav>
          <ul>
            <li>
              <a
                href={`https://cancercare.siemens-healthineers.com/resources-support/treatment-locator`}
                target="_blank"
              >
                {translations?.treatment_locator}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};
export default TopHeaderBar;
